import { Component, OnInit } from '@angular/core';
import { ServiceService } from '../service.service';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-consultation',
  templateUrl: './consultation.component.html',
  styleUrls: ['./consultation.component.scss']
})
export class ConsultationComponent implements OnInit {
  cons_data:any;
  coN_PR_Id_FK=[{}]
  servchargedata:any;
  pat_id:any;
  firstName:any;
  emailId:any;
  phoneNumber:any;
  result:any;
  // token:any;
  searchDoctor: string = '';
  paymentLandingUrl: string;
  isNormal: boolean = true;
  spec_data: any;
  resultPayData: any;
  constructor(private router:Router,private service:ServiceService) { }

  ngOnInit(): void {
    this.pat_id=localStorage.getItem('Id');
    this.firstName=localStorage.getItem('firstName');
    this.emailId=localStorage.getItem('emailId');
    this.phoneNumber=localStorage.getItem('phoneNumber');
    // this.token=localStorage.getItem('access_token');
    this.paymentLandingUrl = environment.pay_landing_url;
    this.get_consultationdetails();
   
  }

  get_consultationdetails(){
    this.service.Get_consultant_byId().subscribe(data=>{     
      //console.log('consulation data :' ,JSON.stringify(data))
      this.cons_data=data
  
    })
  }

  get_specialistdetails(){
    this.service.get_specialistdetails().subscribe(data=>{     
      //console.log('consulation data :' ,JSON.stringify(data))
      this.spec_data=data
  
    })
  }

  toggleButtonText() {
    this.isNormal = !this.isNormal;
    if (this.isNormal) {
      this.get_consultationdetails();
    } else {
      this.get_specialistdetails();
    }
  }

  PayNowSpec(cons_id_fk, csP_DO_Id_FK,csP_PR_Id_FK): void {
    const paydata = {
      cons_id: cons_id_fk,
      pr_id: csP_PR_Id_FK,
      do_id: csP_DO_Id_FK,
      payment_from: "PORTAL SPECIALIST",
    };

    this.service.ProcessRequestOrder_Spec(paydata).subscribe(
      (res) => {
        console.log('Complete Response:', res); // Inspect the full response here
        
        if (res) {
          // Try accessing transaction_id
          this.resultPayData = res;
          
          console.log('Transaction ID:', this.resultPayData.transaction_id);
          if (this.resultPayData.transaction_id) {
            console.log('Transaction ID exists:', this.resultPayData.transaction_id);
           
             this.router.navigate(['/base/patient/payment-form/' + this.resultPayData.transaction_id]);
           
          } else {
            console.log('Transaction ID is undefined or null');
          }
        } else {
          console.log('Response is undefined or null');
        }
      },
      (error) => {
        console.error('Error:', error);
      }
    );

    // const url = this.constructPaymentUrlSpec(paydata);
    // window.open(url, "_blank");
  }
  
  // constructPaymentUrlSpec(paydata: any): string {
  //   console.log("landing url :" +this.paymentLandingUrl);
  //   const baseUrl = this.paymentLandingUrl;
  //   debugger
  //   const queryParams = new URLSearchParams({
  //     cons_id: paydata.cons_id,
  //     pr_id: paydata.pr_id,
  //     do_id: paydata.do_id,
  //     url: 'specialist'
  //   });

  //   return `${baseUrl}?${queryParams.toString()}`;
  // }
  

 

  // PayNow(cons_id, doc_id,pr_id,charges){
  //   var paydata={
  //     consulation_id:cons_id,
  //     doctor_id: doc_id,
  //     patient_id:pr_id,
  //     name: this.firstName,
  //     email:this.emailId,
  //     phone: this.phoneNumber,      
  //     amount: parseInt(charges)
  //   } 
  //   console.log('pay data :', JSON.stringify(paydata))      
  //    this.service.CreatePaymentRequest(paydata)
  //       .subscribe((data) => {
  //       this.result=data;     
  //       console.log("payment url: " +JSON.stringify(this.result));          
  //       this.openPayLink(this.result.value)      
     
  //     }, (error) => {
  //       alert(error.error.errorMessage)
        
  //     });   


  // }


  PayNow(cons_id, doc_id,pr_id,charges): void {
    const paydata = {
      cons_id: cons_id,
      pr_id: pr_id,
      do_id: doc_id,
      payment_from: "PORTAL NORMAL",
    };

    // const url = this.constructPaymentUrl(paydata);
    // window.open(url, "_blank");
    this.service.ProcessRequestOrder(paydata).subscribe(
      (res) => {
        console.log('Complete Response:', res); // Inspect the full response here
        
        if (res) {
          // Try accessing transaction_id
          this.resultPayData = res;
          
          console.log('Transaction ID:', this.resultPayData.transaction_id);
          if (this.resultPayData.transaction_id) {
            console.log('Transaction ID exists:', this.resultPayData.transaction_id);
           
             this.router.navigate(['/base/patient/payment-form/' + this.resultPayData.transaction_id]);
           
          } else {
            console.log('Transaction ID is undefined or null');
          }
        } else {
          console.log('Response is undefined or null');
        }
      },
      (error) => {
        console.error('Error:', error);
      }
    );
  }
  
  // constructPaymentUrl(paydata: any): string {
  //   console.log("landing url :" +this.paymentLandingUrl);
  //   const baseUrl = this.paymentLandingUrl;
  //   debugger
  //   const queryParams = new URLSearchParams({
  //     cons_id: paydata.cons_id,
  //     pr_id: paydata.pr_id,
  //     do_id: paydata.do_id,
  //     // url: 'hospitalpvt'
  //     url: 'demo'
  //   });

  //   return `${baseUrl}?${queryParams.toString()}`;
  // }
  

  // openPayLink(url: string){
  //       window.open(url, "_blank");
  // }
  applySearch() {
    const searchValue = this.searchDoctor.toLowerCase().trim();
    if (!searchValue) {
      // If search input is empty, reset the data
      this.get_consultationdetails();
      this.get_specialistdetails();
      return;
    }

    // Filter appointments based on doctor's name
    this.cons_data = this.cons_data.filter(consultant => {
      return (
        consultant.coN_DO_Name.toLowerCase().includes(searchValue)
      );
    });

    this.spec_data = this.spec_data.filter(consultant => {
      return (
        consultant.csP_DO_Name.toLowerCase().includes(searchValue)
      );
    });
  }

}
